/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
import bsCustomFileInput from "bs-custom-file-input";

var w = $(window);
var body = $("html,body");
var headerHeight = $("header").height();

$(function() {
  if ($(".landing-v2").length) {
    // Desplegar menú
    $("#menu-ico").on("click", function() {
      $(this).toggleClass("open");
      $("#header .menu-content").slideToggle("slow");
      $("#header").toggleClass("active");
    });

    // Header on scroll
    if (w.scrollTop() > headerHeight - 1) {
      $("header").addClass("active");
      console.log(w.scrollTop());
      console.log(headerHeight);
    }
    w.on("scroll", function() {
      $("header").toggleClass("active", w.scrollTop() > headerHeight - 1);
    });

    // Scroll menú
    $(".menu-content li a").on("click", function(e) {
      if (!$(this).hasClass("menu-accedeix")) {
        e.preventDefault();
        const menuClass = $(this).attr("href");
        const sectionTop = $("#" + menuClass).offset().top;
        body.animate({ scrollTop: sectionTop - headerHeight }, 1500);
      }
    });

    // Nav
    $("section").each(function() {
      const sectAnchor = $(this).attr("data-anchor");
      const sectTitle = $(this).attr("data-title");
      $("#fp-nav ul").append(
        '<li class="' +
          sectAnchor +
          '" data-anchor="' +
          sectAnchor +
          '" data-title="' +
          sectTitle +
          '"><span></span><div class="fp-tooltip">' +
          sectTitle +
          "</div></li>"
      );
    });
    w.on("scroll", function() {
      const cutoff = w.scrollTop();
      $("section").each(function() {
        $("#fp-nav li").removeClass("active");
        const anchor = $(this).attr("data-anchor");
        if ($(this).offset().top + $(this).height() > cutoff) {
          if (!$("#fp-nav  ." + anchor).hasClass("active")) {
            $("#fp-nav  ." + anchor).addClass("active");
            return false;
          }
        }
      });
    });
    const cutoff = w.scrollTop();
    $("section").each(function() {
      const anchor = $(this).attr("data-anchor");
      if ($(this).offset().top + $(this).height() > cutoff) {
        $("#fp-nav  ." + anchor).addClass("active");
        return false;
      }
    });
    $("#fp-nav li").on("click", function(e) {
      e.preventDefault();
      const thHref = $(this).attr("data-anchor");
      $("html, body").animate(
        {
          scrollTop: $('section[data-anchor="' + thHref + '"]').offset().top
        },
        800
      );
    });

    // Sliders
    $(".init-slider").flickity({
      cellSelector: ".slide",
      autoPlay: 4000,
      prevNextButtons: false,
      wrapAround: true,
      pageDots: true,
      pauseAutoPlayOnHover: false,
      adaptiveHeight: true
    });

    $("#qui-som .slider").flickity({
      cellSelector: ".slide",
      autoPlay: 4000,
      prevNextButtons: false,
      wrapAround: true,
      pageDots: false,
      pauseAutoPlayOnHover: false
    });
  }

  $(".list-group-item .btn-mesinfo").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    $.get(
      "/platmodal/" +
        $(this)
          .parent()
          .attr("data-id"),
      function(data) {
        $("#platInfoLabel span").text(data.nom);
        $(".ingredients-container").html(data.ingredients);
        $(".valors-container").html(data.valors);
        $(".alergens-container").html(data.alergens);
        $(".quantitat-container").html(data.quant ? data.quant + "g" : "");
      }
    );
    $("#platInfo").modal("show");
  });

  bsCustomFileInput.init();

  $(function() {
    $('[data-toggle="tooltip"]').tooltip();
  });
  if ($(".rellotge").length) {
    const eventTime = $(".rellotge").attr("data-limit");
    const currentTime = $(".rellotge").attr("data-now");
    const diffTime = eventTime - currentTime;
    const duration = moment.duration(diffTime * 1000, "milliseconds");
    $(".countdown").text(
      addZeros(
        duration.days(),
        duration.hours(),
        duration.minutes(),
        duration.seconds()
      )
    );
    const interval = 1000;
    function addZeros(d, h, m, s) {
      return (
        (h ? h + d * 24 + "h " : "") +
        (m ? +m + "min " : "") +
        (s ? s + "s" : "")
      );
    }

    const rellotge = setInterval(function() {
      const newDur = duration - interval;
      if (newDur) {
        duration = moment.duration(newDur, "milliseconds");
        $(".countdown").text(
          addZeros(
            duration.days(),
            duration.hours(),
            duration.minutes(),
            duration.seconds()
          )
        );
      } else {
        window.location.reload(false);
      }
    }, interval);
  }

  // Habilitar botó de guardar menú empresa
  $(".empreses-menudia .list-group-item").on("click", function() {
    const plat = $(this).attr("data-id");
    const pos = $(this)
      .parent()
      .attr("data-posicio");
    $("[data-posicio=" + pos + "]")
      .next("input")
      .val(plat);
    if (pos == 4) {
      if ($(this).hasClass("list-complement")) {
        if ($(this).hasClass("active")) {
          $(this)
            .next("input")
            .val("");
        } else {
          $(this)
            .next("input")
            .val(plat);
        }
      }
    }
    setTimeout(function() {
      if (
        $("[data-posicio='0'] .active,[data-posicio='1'] .active").length >=
          1 ||
        $("[data-posicio='3'] .active").length
      ) {
        // Postre?
        if ($("[data-posicio='2']").length) {
          if ($("[data-posicio='2'] .active").length) {
            $(".btn-next").prop("disabled", false);
          } else {
            $(".btn-next").prop("disabled", true);
          }
        } else {
          $(".btn-next").prop("disabled", false);
        }
      } else {
        $(".btn-next").prop("disabled", true);
      }
      if ($(".plat .list-group-item.active[data-alergens]").length) {
        $(".alert.alergens").fadeIn();
      } else {
        $(".alert.alergens").fadeOut();
      }
    }, 100);
  });

  $(".botiga .list-group-item").on("click", function() {
    const plat = $(this).attr("data-id");
    const pos = $(this)
      .parent()
      .attr("data-posicio");
    $("[data-posicio=" + pos + "]")
      .next("input")
      .val(plat);
    setTimeout(function() {
      const active =
        $("[data-posicio='0'] .active").length &&
        $("[data-posicio='1'] .active").length;
      $(".btn-next").prop("disabled", !active);
    }, 100);
  });

  $(".check-alergic input").on("change", function() {
    const checked = $(this).prop("checked");
    const altres = parseInt($("input[name='altres']").val());
    if (checked) {
      $("input[name='altres']").val(altres + 1);
    } else {
      $("input[name='altres']").val(altres - 1);
    }
  });

  // Evitar guardar un menú buit
  $(".menu-guardat").on("submit", function(e) {
    let check = false;
    $(".menu-guardat input").each(function() {
      if ($(this).val() != "") {
        check = true;
        return false;
      }
    });
    if (!check) {
      alert("El formulari està buii!");
      e.preventDefault();
      return false;
    }
  });

  if ($(".admin").length) {
    if (typeof events !== "undefined") {
      $(".calendari").clndr({
        moment: moment,
        events: events,
        daysOfTheWeek: ["Dl", "Dt", "Dc", "Dj", "Dv", "Ds", "Dg"],
        constraints: {
          startDate: events[0].date,
          endDate: events[events.length - 1].date
        },
        clickEvents: {
          click: function(target) {
            if (target.events) {
              const newurl =
                $(".calendari").attr("data-url") + target.events[0].date;
              //console.log(newurl);
              window.location = newurl;
            }
          }
        }
      });
    }
  }
});
